export default __webpack_public_path__ + "static/media/misty_thumbnail.e2edbafb.jpg";